var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8264 43.8037C23.2202 44.0207 23.6638 44.1316 24.1134 44.1255C24.5631 44.1195 25.0035 43.9967 25.3914 43.7692C30.7674 40.6987 40.1064 33.6277 43.7739 24.4432C49.1589 12.4837 36.5169 2.93769 27.7809 9.80319C26.8689 10.5202 25.7229 11.3407 24.9354 12.1162C24.5784 12.4672 23.9499 12.5032 23.5794 12.1672C22.5444 11.2222 20.9229 10.0132 19.8819 9.30969C12.4344 4.26969 -1.11814 10.9132 4.66286 25.0897C6.78086 31.4527 16.8729 40.4797 22.8264 43.8037Z",
    fill: "url(#paint0_radial_1690_3137)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8264 43.8037C23.2202 44.0207 23.6638 44.1316 24.1134 44.1255C24.5631 44.1195 25.0035 43.9967 25.3914 43.7692C30.7674 40.6987 40.1064 33.6277 43.7739 24.4432C49.1589 12.4837 36.5169 2.93769 27.7809 9.80319C26.8689 10.5202 25.7229 11.3407 24.9354 12.1162C24.5784 12.4672 23.9499 12.5032 23.5794 12.1672C22.5444 11.2222 20.9229 10.0132 19.8819 9.30969C12.4344 4.26969 -1.11814 10.9132 4.66286 25.0897C6.78086 31.4527 16.8729 40.4797 22.8264 43.8037Z",
    fill: "url(#paint1_radial_1690_3137)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8264 43.8037C23.2202 44.0207 23.6638 44.1316 24.1134 44.1255C24.5631 44.1195 25.0035 43.9967 25.3914 43.7692C30.7674 40.6987 40.1064 33.6277 43.7739 24.4432C49.1589 12.4837 36.5169 2.93769 27.7809 9.80319C26.8689 10.5202 25.7229 11.3407 24.9354 12.1162C24.5784 12.4672 23.9499 12.5032 23.5794 12.1672C22.5444 11.2222 20.9229 10.0132 19.8819 9.30969C12.4344 4.26969 -1.11814 10.9132 4.66286 25.0897C6.78086 31.4527 16.8729 40.4797 22.8264 43.8037Z",
    fill: "url(#paint2_radial_1690_3137)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8264 43.8037C23.2202 44.0207 23.6638 44.1316 24.1134 44.1255C24.5631 44.1195 25.0035 43.9967 25.3914 43.7692C30.7674 40.6987 40.1064 33.6277 43.7739 24.4432C49.1589 12.4837 36.5169 2.93769 27.7809 9.80319C26.8689 10.5202 25.7229 11.3407 24.9354 12.1162C24.5784 12.4672 23.9499 12.5032 23.5794 12.1672C22.5444 11.2222 20.9229 10.0132 19.8819 9.30969C12.4344 4.26969 -1.11814 10.9132 4.66286 25.0897C6.78086 31.4527 16.8729 40.4797 22.8264 43.8037Z",
    fill: "url(#paint3_radial_1690_3137)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8264 43.8037C23.2202 44.0207 23.6638 44.1316 24.1134 44.1255C24.5631 44.1195 25.0035 43.9967 25.3914 43.7692C30.7674 40.6987 40.1064 33.6277 43.7739 24.4432C49.1589 12.4837 36.5169 2.93769 27.7809 9.80319C26.8689 10.5202 25.7229 11.3407 24.9354 12.1162C24.5784 12.4672 23.9499 12.5032 23.5794 12.1672C22.5444 11.2222 20.9229 10.0132 19.8819 9.30969C12.4344 4.26969 -1.11814 10.9132 4.66286 25.0897C6.78086 31.4527 16.8729 40.4797 22.8264 43.8037Z",
    fill: "url(#paint4_linear_1690_3137)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8264 43.8037C23.2202 44.0207 23.6638 44.1316 24.1134 44.1255C24.5631 44.1195 25.0035 43.9967 25.3914 43.7692C30.7674 40.6987 40.1064 33.6277 43.7739 24.4432C49.1589 12.4837 36.5169 2.93769 27.7809 9.80319C26.8689 10.5202 25.7229 11.3407 24.9354 12.1162C24.5784 12.4672 23.9499 12.5032 23.5794 12.1672C22.5444 11.2222 20.9229 10.0132 19.8819 9.30969C12.4344 4.26969 -1.11814 10.9132 4.66286 25.0897C6.78086 31.4527 16.8729 40.4797 22.8264 43.8037Z",
    fill: "url(#paint5_linear_1690_3137)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8264 43.8037C23.2202 44.0207 23.6638 44.1316 24.1134 44.1255C24.5631 44.1195 25.0035 43.9967 25.3914 43.7692C30.7674 40.6987 40.1064 33.6277 43.7739 24.4432C49.1589 12.4837 36.5169 2.93769 27.7809 9.80319C26.8689 10.5202 25.7229 11.3407 24.9354 12.1162C24.5784 12.4672 23.9499 12.5032 23.5794 12.1672C22.5444 11.2222 20.9229 10.0132 19.8819 9.30969C12.4344 4.26969 -1.11814 10.9132 4.66286 25.0897C6.78086 31.4527 16.8729 40.4797 22.8264 43.8037Z",
    fill: "url(#paint6_radial_1690_3137)",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1690_3137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8633 15.8103V26.0448C23.8633 27.4023 25.5073 28.0458 26.3533 26.9853C28.9708 23.7003 31.0828 19.7088 28.7263 16.4478C27.8233 15.1968 26.0923 14.3958 24.6778 14.6508C24.1498 14.7453 23.8633 15.2733 23.8633 15.8118",
    fill: "#FA1C56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1690_3137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8644 21.0457C43.5148 18.4692 43.9314 14.5987 41.7949 12.4009C39.6583 10.2031 35.7777 10.5101 33.1272 13.0867C30.4768 15.6632 30.0601 19.5336 32.1967 21.7315C34.3332 23.9293 38.2139 23.6223 40.8644 21.0457Z",
    fill: "url(#paint7_radial_1690_3137)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1690_3137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1247 9.63031C36.5163 9.80524 37.6742 9.70984 37.711 9.41723C37.7478 9.12461 36.6495 8.74558 35.2579 8.57065C33.8664 8.39572 32.7085 8.49112 32.6717 8.78374C32.6349 9.07635 33.7332 9.45538 35.1247 9.63031Z",
    fill: "#FF7383"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1690_3137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0882 9.4536C15.3465 9.4383 16.3645 9.25868 16.362 9.05241C16.3595 8.84615 15.3374 8.69135 14.0791 8.70666C12.8208 8.72197 11.8028 8.90158 11.8053 9.10785C11.8078 9.31411 12.8299 9.46891 14.0882 9.4536Z",
    fill: "#FF93BA",
    fillOpacity: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1690_3137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2682 14.9428L22.7377 30.3178C12.4252 20.2858 10.4407 13.2418 14.3932 11.6608C18.1432 10.1608 21.1432 12.5983 22.2682 14.9428Z",
    fill: "url(#paint8_radial_1690_3137)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1690_3137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5195 14.0434C20.2595 13.8634 19.8695 12.8179 19.832 12.3184C20.552 13.0684 21.257 13.1314 21.5195 13.0684V14.0434Z",
    fill: "#FF7383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1690_3137",
    x: 22.8633,
    y: 13.6035,
    width: 7.88477,
    height: 14.9116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1690_3137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1690_3137",
    x: 30.0815,
    y: 10.1841,
    width: 13.8286,
    height: 13.7643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_1690_3137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1690_3137",
    x: 31.6709,
    y: 7.48309,
    width: 7.04102,
    height: 3.23477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1690_3137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1690_3137",
    x: 11.0552,
    y: 7.95563,
    width: 6.05664,
    height: 2.24902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_1690_3137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1690_3137",
    x: 11,
    y: 9.69922,
    width: 13.2378,
    height: 22.1185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_1690_3137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1690_3137",
    x: 19.332,
    y: 11.8184,
    width: 2.6875,
    height: 2.72501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_1690_3137"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1690_3137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8254 8.45169) rotate(90) scale(34.4767 36.6032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#FF3B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F724B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1690_3137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5384 17.0452) rotate(134.402) scale(31.897 59.7462)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#C82092",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#C82092"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1690_3137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9964 26.6842) rotate(-158.663) scale(34.1235 48.2385)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B91D43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#B91D43"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1690_3137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3409 20.7247) rotate(90) scale(29.6988 29.6988)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1690_3137",
    x1: 26.6184,
    y1: 24.2002,
    x2: 38.6379,
    y2: 38.5042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1690_3137",
    x1: 25.1289,
    y1: 24.7957,
    x2: 11.0244,
    y2: 40.6882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1690_3137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5214 19.3447) rotate(164.618) scale(25.8219 27.2703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#FF73A6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF93BA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1690_3137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.6586 12.2727) rotate(128.737) scale(10.9371 14.5434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7383",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1690_3137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5182 20.7598) rotate(-135.591) scale(19.0292 33.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6274",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkHeart);
export default __webpack_public_path__ + "static/media/pink-heart.7392b8b01ccdcb8649bf278932f6c7aa.svg";
export { ForwardRef as ReactComponent };